/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_YouInputs */

const th_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณ`)
};

const en_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You`)
};

const ja_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなた`)
};

const zh_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你`)
};

const es_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tú`)
};

const pt_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você`)
};

const id_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda`)
};

const fr_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous`)
};

const tl_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikaw`)
};

const vi_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn`)
};

const ko_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나`)
};

const de_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du`)
};

const ru_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы`)
};

const tr_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siz`)
};

const it_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu`)
};

const pl_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ty`)
};

const uk_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви`)
};

const hi_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप`)
};

const ar_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنت`)
};

const ms_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda`)
};

const bn_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি`)
};

const zh_tw2_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你`)
};

const zh_hk2_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你`)
};

const ur_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ`)
};

const fa_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شما`)
};

const sw_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wewe`)
};

const nl_meeting_you = /** @type {(inputs: Meeting_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jij`)
};

/**
* | output |
* | --- |
* | "You" |
*
* @param {Meeting_YouInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_you = /** @type {((inputs?: Meeting_YouInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_YouInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_you(inputs)
	if (locale === "ja") return ja_meeting_you(inputs)
	if (locale === "zh") return zh_meeting_you(inputs)
	if (locale === "es") return es_meeting_you(inputs)
	if (locale === "pt") return pt_meeting_you(inputs)
	if (locale === "id") return id_meeting_you(inputs)
	if (locale === "fr") return fr_meeting_you(inputs)
	if (locale === "tl") return tl_meeting_you(inputs)
	if (locale === "vi") return vi_meeting_you(inputs)
	if (locale === "ko") return ko_meeting_you(inputs)
	if (locale === "de") return de_meeting_you(inputs)
	if (locale === "ru") return ru_meeting_you(inputs)
	if (locale === "tr") return tr_meeting_you(inputs)
	if (locale === "it") return it_meeting_you(inputs)
	if (locale === "pl") return pl_meeting_you(inputs)
	if (locale === "uk") return uk_meeting_you(inputs)
	if (locale === "hi") return hi_meeting_you(inputs)
	if (locale === "ar") return ar_meeting_you(inputs)
	if (locale === "ms") return ms_meeting_you(inputs)
	if (locale === "bn") return bn_meeting_you(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_you(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_you(inputs)
	if (locale === "ur") return ur_meeting_you(inputs)
	if (locale === "fa") return fa_meeting_you(inputs)
	if (locale === "sw") return sw_meeting_you(inputs)
	if (locale === "nl") return nl_meeting_you(inputs)
	return en_meeting_you(inputs)
});